const handleClickDeleteChecklistModalEquipService = {
  confirm: 'Deseja realmente deletar o checklist completo para esse site?',
  title: 'DELETAR CHECKLIST'
}

export default handleClickDeleteChecklistModalEquipService;
